export default `
<label class="master-checkbox alert alert-form" ng-class="{'alert-success': ngModel}" >
  <div class="cus-checkbox inline">
    <input ng-model-options="{debounce: 800}" type="checkbox" id="{{id}}" ng-model="ngModel" ng-change="toggleComplete()">
    <div class="checkbox-toggle noselect"></div>
  </div>
  <span ng-transclude ></span>
</label>
`;
